/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Permission_Name_Custompropertyrules_ReadInputs */

const en_enum_permission_name_custompropertyrules_read = /** @type {(inputs: Enum_Permission_Name_Custompropertyrules_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Custompropertyrules Read`)
};

const de_enum_permission_name_custompropertyrules_read = /** @type {(inputs: Enum_Permission_Name_Custompropertyrules_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Custompropertyrules Read`)
};

/**
* | output |
* | --- |
* | "Name Custompropertyrules Read" |
*
* @param {Enum_Permission_Name_Custompropertyrules_ReadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_permission_name_custompropertyrules_read = /** @type {((inputs?: Enum_Permission_Name_Custompropertyrules_ReadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Permission_Name_Custompropertyrules_ReadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_permission_name_custompropertyrules_read(inputs)
	return de_enum_permission_name_custompropertyrules_read(inputs)
});